import { defineComponent as _defineComponent } from 'vue'
import {
  ButtonContainer,
  ButtonSecondary,
  HelperViewStatus,
  NavBar
} from '@warrenbrasil/nebraska-web';
import { BackButton } from '@/modules/common/components/buttons';
import { ref } from 'vue';
import { ModalPassword } from '../ModalPassword';
import { useRouter } from 'vue-router/composables';
import { notify } from '@/modules/common/helpers/notification';
import { NotificationTypes } from '@/modules/common/services/http/notification';
import { canceledPaidCustody } from '@/modules/trade/services/paid-custody';


export default /*#__PURE__*/_defineComponent({
  __name: 'PaidCustodyCancel',
  setup(__props) {

const router = useRouter();
const showModalPassword = ref(false);
const loadingPassword = ref(false);

const handleNextClick = () => {
  showModalPassword.value = true;
};

const handleCloseModalPassword = () => {
  showModalPassword.value = false;
};

const handleConfirmPassword = async () => {
  try {
    loadingPassword.value = true;
    const response = await canceledPaidCustody();

    router.replace({ name: 'trade' });

    if (response.message) {
      return notify({
        group: 'wrn-notifications',
        text: response.message,
        type: NotificationTypes.success
      });
    } else {
      return notify({
        group: 'wrn-notifications',
        text: 'Custódia remunerada desativada.',
        type: NotificationTypes.success
      });
    }
  } catch (e) {
    router.replace({ name: 'trade' });

    return notify({
      group: 'wrn-notifications',
      text: 'Não foi possível cancelar a custódia remunerada, tente novamente.',
      type: NotificationTypes.error
    });
  } finally {
    loadingPassword.value = false;
  }
};

return { __sfc: true,router, showModalPassword, loadingPassword, handleNextClick, handleCloseModalPassword, handleConfirmPassword, ButtonContainer, ButtonSecondary, HelperViewStatus, NavBar, BackButton, ModalPassword }
}

})